import React, { Component } from "react";
import PropType from "prop-types";
import { TextInput } from "../TextInput";
import TextArea from "../TextArea";
import style from "./style.module.scss";
import { wordCharacterCount } from "../../utils/wordCharacterCount.utils";
const TEXT_AREA_CHARACTER_LIMIT = 1500;
const TEXT_INPUT_CHARACTER_LIMIT = 50;
export default class FormField extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isFocused: null,
			wordCharacterCount: `0/0/${this.props.maxLength || TEXT_AREA_CHARACTER_LIMIT
				}`,
		};
	}
	onFocus = (event) => {
		this.setState({ isFocused: event.target.name });
	};
	onLabelFocus = (event) => {
		this.setState({ isFocused: event.target.name });
		document.getElementById(this.props.name).focus();
	};
	onBlur = (event) => {
		this.setState({ isFocused: null });
	};

	generateCharacterWordCountTextArea = (e) => {
		const { wordCount, charCount } = wordCharacterCount(e.target.value);
		if (this.props.limit === false) {
			if (this.props.showCharOnly) {
				this.setState({
					wordCharacterCount: `${charCount}`,
				});
			} else {
				this.setState({
					wordCharacterCount: `${wordCount}/${charCount}`,
				});
			}
		} else {
			if (this.props.showCharOnly) {
				this.setState({
					wordCharacterCount: `${charCount}/${this.props.maxLength || TEXT_AREA_CHARACTER_LIMIT
						}`,
				});
			} else {
				this.setState({
					wordCharacterCount: `${wordCount}/${charCount}/${this.props.maxLength || TEXT_AREA_CHARACTER_LIMIT
						}`,
				});
			}
		}
	};

	render() {
		const { isFocused } = this.state;
		const { name, value } = this.props;
		const { error } = this.props;
		let isFieldActive = false;
		let haveValue = false;
		if (isFocused === name) {
			isFieldActive = true;
		}
		if (value !== "") {
			haveValue = true;
		}
		return (
			<div className={style.formFeild}>
				<div
					className={`${style.feildBox} ${error ? style.error : isFieldActive ? style.active : haveValue ? style.textedItem : null
						}`}>
					<label
						onClick={() => {
							this.onLabelFocus({
								target: { name: this.props.name },
							});
						}}
						htmlFor={this.props.htmlForName}>
						<span className={style.labelBlock}>{this.props.title}</span>
						{this.props.isRequired ? (
							<span className={style.starIcon}>*</span>
						) : (
							""
						)}
					</label>

					<div className={style.inputPane}>
						<InputTypes
							{...this.props}
							onFocus={this.onFocus}
							onBlur={this.onBlur}
							isFieldActive={isFieldActive}
							wordCharacterCount={this.generateCharacterWordCountTextArea}
							hidePlaceHolder={true}
							id={name}
						/>
					</div>
				</div>
				{this.props.hint || this.props.inputType === "textArea" || this.props.showCounter ? (
					<div className={style.infoPane}>
						{this.props.hint ? (
							<hint className={`${style.formHint}`}>{this.props.hint}</hint>
						) : null}
						{(this.props.inputType === "textArea" && this.props.showCounter) || this.props.showCounter ? (
							<span className={style.textRight}>
								{this.state.wordCharacterCount}
							</span>
						) : null}
					</div>
				) : null}
			</div>
		);
	}
}
FormField.Prototype = {
	className: PropType.string,
	type: PropType.string,
	placeholder: PropType.string,
	value: PropType.string,
	name: PropType.string.isRequired,
};

function InputTypes(props) {
	const { inputType } = props;
	switch (inputType) {
		case "textArea":
			return (
				<TextArea
					className={style.areaItem}
					{...props}
				/>
			);
		default:
			return (
				<TextInput
					className={style.inputItem}
					{...props}
				/>
			);
	}
}
